export default {
  init() {
    const searchFilter = document.getElementById('search-filter');
    const searchFilterTmp = document.getElementById('search-filter-transfer');
    if (searchFilter && searchFilterTmp) {
      const els = searchFilterTmp.querySelectorAll('li');
      if (els.length > 0) {
        Array.from(els).forEach(el => {
          searchFilter.appendChild(el);
        })
      }
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js